import { VersionChangeManager } from "../../oss/modern-idb/index.js";
import { Indexes, Schema } from "./types.js";

type Manager = VersionChangeManager<Schema, Indexes>;

export function initDatabase(props: { manager: Manager }) {
  const store = props.manager.createObjectStore("armies", { keyPath: "id" });
  store.createIndex("created_ts_idx", "created_ts");
  store.createIndex("updated_ts_idx", "updated_ts");
  store.createIndex("ruleset_version_idx", "ruleset_version");

  console.info("DB initialized.");
}
